import { render, staticRenderFns } from "./listAwardGame.vue?vue&type=template&id=92d22964"
import script from "./listAwardGame.vue?vue&type=script&lang=js"
export * from "./listAwardGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports